export class SearchCriteria {
  constructor(
    isAdvanced,
    searchData,
    searchFilter,
    filterCriteria,
    filterTags,
    columnHeader,
    pageNumber,
    pageSize
  ) {
    this.isAdvanced = isAdvanced;
    this.searchData = searchData;
    this.searchFilter = searchFilter;
    this.filterCriteria = filterCriteria;
    this.filterTags = filterTags;
    this.columnHeader = columnHeader;
    this.pageNumber = pageNumber
    this.pageSize = pageSize
  }
  public isAdvanced: boolean;
  public searchData: [];
  public searchFilter: any;
  public filterCriteria: [];
  public filterTags: [];
  public columnHeader: [];
  public pageNumber;
  public pageSize;
}
